import React from 'react';

const barStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '10px 20px',
  backgroundColor: '#fef3c7',
  borderBottom: '1px solid #f59e0b',
  color: '#92400e',
  fontSize: '14px',
  fontWeight: 500,
};

const buttonStyle = {
  padding: '4px 14px',
  fontSize: '13px',
  fontWeight: 'bold',
  backgroundColor: '#f59e0b',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const StaleVersionBar = ({ onReload, staleSections }) => {
  return (
    <div style={barStyle}>
      <span>This schedule has been updated elsewhere.</span>
      <button style={buttonStyle} onClick={onReload}>
        Reload
      </button>
    </div>
  );
};

export default StaleVersionBar;
